import { render, staticRenderFns } from "./TermsAndConditionView.vue?vue&type=template&id=9a5f27da&scoped=true&"
import script from "./TermsAndConditionView.vue?vue&type=script&lang=ts&"
export * from "./TermsAndConditionView.vue?vue&type=script&lang=ts&"
import style0 from "./TermsAndConditionView.vue?vue&type=style&index=0&id=9a5f27da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a5f27da",
  null
  
)

export default component.exports